import { DefaultMantineColor, MantineThemeOverride, Tuple } from '@mantine/core';

type ExtendColors = 'kiloBlue' | DefaultMantineColor;

declare module '@mantine/core' {
  export interface MantineThemeColorsOverride {
    colors: Record<ExtendColors, Tuple<string, 10>>;
  }
}

export const demoGymColors = {
  bannerBg: '#042533',
  bannerInnerComponentBg: '#2b4652',
};

const kiloBlue: Tuple<string, 10> = [
  '#FCFEFF',
  '#BFECFF',
  '#97DFFF',
  '#72D4FF',
  '#50CAFF',
  '#32C0FF',
  '#16B8FF',
  '#00AFFC',
  '#009EE3',
  '#008ECC',
];

// https://github.com/mantinedev/mantine/blob/master/src/mantine-styles/src/theme/default-theme.ts
export const lightTheme: MantineThemeOverride = {
  colorScheme: 'light',
  defaultRadius: 'md',
  colors: {
    kiloBlue,
  },
  primaryColor: 'kiloBlue',
  fontFamily: 'Inter, sans-serif',

  breakpoints: {
    xs: '26em', // 416px
    sm: '40em', // 640px
    md: '62em', // 992px
    lg: '75em', // 1200px
    xl: '88em', // 1408px
  },

  other: {
    fontWeights: {
      lightBold: 410,
      semibold: 500,
    },
  },

  components: {
    Drawer: {
      defaultProps: {
        keepMounted: false,
      },
    },

    InputWrapper: {
      styles: theme => ({
        label: {
          color: theme.colors.gray[6],
          fontStyle: 'italic',
        },
      }),
    },

    Checkbox: {
      styles: theme => ({
        label: {
          color: theme.colors.gray[6],
          fontStyle: 'italic',
        },
      }),
    },

    DateInput: {
      defaultProps: {
        weekendDays: [],
        firstDayOfWeek: 0,
      },
    },

    DatePickerInput: {
      defaultProps: {
        weekendDays: [],
        firstDayOfWeek: 0,
      },
    },

    DatePicker: {
      defaultProps: {
        weekendDays: [],
        firstDayOfWeek: 0,
      },
    },

    TimeInput: {
      styles: {
        input: {
          '&::-webkit-calendar-picker-indicator': {
            display: 'block',
          },
        },
      },
    },

    Tabs: {
      defaultProps: {
        variant: 'outline',
        radius: 'md',
      },
      styles: theme => ({
        tab: {
          '&[data-active]': {
            backgroundColor: theme.white,
          },
        },
        tabsList: {
          background: theme.colors.gray[0],
        },
      }),
      variants: {
        pills: theme => ({
          tab: {
            '&[data-active]': {
              backgroundColor: theme.white,
              color: theme.black,
              boxShadow: theme.shadows.md,
            },
            '&[data-active]:hover': {
              backgroundColor: theme.white,
              color: theme.black,
              boxShadow: theme.shadows.xs,
            },
          },
        }),
      },
    },
  },
};

export const darkTheme: MantineThemeOverride = {
  ...lightTheme,
  colorScheme: 'dark',
};
